// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import store from './vuex/store'
import VueRouter from 'vue-router'
import routerConfig from './router'
import ElementUI from 'element-ui'
import Filter from './mixin/filters'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import 'element-ui/lib/index.js'
import auth from '@/utils/auth'
import {parseTime} from '@/utils'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { getAllDicts } from '@/api/data'
// 常量
import Constant from './assets/js/Constant'
// import el from 'element-ui/lib/locale/lang/el';
// import user from "./api/user";
import '@/assets/style/reset.scss'

// 全局方法挂载
Vue.prototype.getAllDicts = getAllDicts
Vue.prototype.Constant = Constant

Vue.use(Viewer)
Vue.use(Vuex)
// 这里是插件的默认设置
Viewer.setDefaults({
  zIndexInline: 9999
})
Vue.use(VueQuillEditor)
Vue.mixin(Filter)
Vue.use(ElementUI, { size: 'small' })
Vue.use(VueRouter)

Vue.filter("parseTime", parseTime)

let versionSign = localStorage.getItem('versionSign2');
if (!versionSign) {
  localStorage.clear();
  localStorage.setItem('versionSign2', '99989416516');
}

const router = new VueRouter(routerConfig)
router.beforeEach((to, from, next) => {
  let userInfo = JSON.parse(localStorage.getItem('userInfo')) //http://testadmin-zjz-haiwai.soouya.cn/
  let isTest = false;
    // location.host === 'testadmin-zjz-haiwai.soouya.cn' ||
    // location.host === 'localhost' ||
    // location.host === 'localhost:6787' ||
    // location.host === 'admin-zjz-haiwai.soouya.cn' ||
    // location.host === '192.168.1.98:6787'
  // 测试代码 start
  if (isTest) {
    let user = (userInfo = {
      extras: {},
      // 'id': 'otrOuwyr8Qct-YjGKK465_nO-nSI',
      id: 'oI-cs5gD2bkhNhU-3a2UI9iyiCao',
      name: '小兔兔',
      roleId: 'kf_m',
      type: 5,
      apkChannel: '',
      del: 0,
      login: 1,
      createTime: 1569477361000,
      loginTime: 1589105827,
      editTime: 1574142009000,
      qq: '254568214'
    })
    localStorage.setItem('userInfo', JSON.stringify(user))
  }
  // 测试代码 end
  if (from.path === '/' || from.path === '/login') {
    // 根据本地缓存/接口更新vuex
    auth.getAuthorizedViewList(true, true)
  }
  if (to.path === '/login') {
    localStorage.removeItem('userInfo')
  }
  if (!userInfo && to.path !== '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
  // else if (userInfo && userInfo.type === 3 && to.path !== '/overseas/list') {
  //     next({ path: '/overseas/list' })
  // } else {
  //     next()
  // }
})
Vue.config.productionTip = false
Vue.config.silent = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js